export default async function AddUserApi(
  employeeId,
  username,
  email,
  positionId,
  requestBy,
  approverId
) {
  let res = "";
  try {
    const body = {
      employeeId: employeeId,
      username: username,
      email: email,
      positionId: positionId,
      requestBy: requestBy,
      approverId: approverId,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/users/add-user`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error add user: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
